module.exports = __webpack_public_path__ + "static/parents-selfie-zoom-80e31ed891c91160c15d731edc311368.jpg";